import { z } from 'zod/v4';

export const serverEnvSchema = z.object({
  NEXT_PUBLIC_APP_URL: z.string().min(1).default('http://localhost:3000'),
});

export type ServerEnv = z.infer<typeof serverEnvSchema>;

const serverEnv = serverEnvSchema.parse({
  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
} satisfies Record<keyof ServerEnv, string | boolean | undefined>);

export default serverEnv;
